import {SeatTypeImage} from '@wix/seating-viewer'
import React from 'react'
import {SeatInfoIconProps} from './interfaces'
import {classes} from './seat-info-icon.st.css'

const RADIUS = 12
const DIAMETER = RADIUS * 2
const OVERFLOW = 1

export const SeatInfoIcon = ({type}: SeatInfoIconProps) => {
  return (
    <svg width={DIAMETER + OVERFLOW} height={DIAMETER + OVERFLOW}>
      <ellipse
        className={classes.iconStroke}
        fill="none"
        rx={RADIUS}
        ry={RADIUS}
        cx={RADIUS + OVERFLOW / 2}
        cy={RADIUS + OVERFLOW / 2}
      />
      <SeatTypeImage x={3.5} y={2.5} type={type} />
    </svg>
  )
}
